import { render, staticRenderFns } from "./QuoteBuilderOtherLabourItem.vue?vue&type=template&id=5e01eb2a"
import script from "./QuoteBuilderOtherLabourItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourItem.vue?vue&type=style&index=0&id=5e01eb2a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e01eb2a')) {
      api.createRecord('5e01eb2a', component.options)
    } else {
      api.reload('5e01eb2a', component.options)
    }
    module.hot.accept("./QuoteBuilderOtherLabourItem.vue?vue&type=template&id=5e01eb2a", function () {
      api.rerender('5e01eb2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderOtherLabour/QuoteBuilderOtherLabourItem.vue"
export default component.exports